
var React = require("react");
var CardActionItem = require("./generic/CardActionItem.jsx");
var DataActionUtil = require("./../../util/DataActionUtil.js");

class DeleteButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
        return <CardActionItem 
                    {...this.props}
                    text={
                        <React.Fragment>
                             <svg width="17px" height="20px" viewBox="0 0 18 21" xmlns="http://www.w3.org/2000/svg">
                                 <use xlinkHref='#delete' />
                             </svg>
                         </React.Fragment>
                     }
                    action={DataActionUtil.deleteAsset}
                    addedClass="delete"
                >
               </CardActionItem>
    }
}

module.exports = DeleteButton;
